<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('reportQcBy.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('reportQcBy.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="md:ts-flex md:ts-space-x-2 ts-items-end ts-space-y-3">
            <div>
              <label>{{ $t('reportQcBy.dateRage') }}</label
              ><br />
              <a-range-picker
                v-model="date_range"
                :allowClear="false"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                style="width:250px"
              ></a-range-picker>
            </div>
            <div>
              <label>{{ $t('reportQcBy.qcName') }}</label
              ><br />
              <a-select
                v-model="qc_by_id"
                showSearch
                style="width: 250px"
                placeholder="All"
                :options="users"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
            <div class="ts-flex ts-space-x-2 ts-h-8">
              <ts-button @click.prevent="fetchData" color="primary">{{
                $t('preview')
              }}</ts-button>
              <ts-button
								@click.prevent="downloadExcel"
								color="info">{{ $t('excel') }}</ts-button>
              <ts-button>{{ $t('cancel') }}</ts-button>
            </div>
          </div>
          <table class="table ts-mt-3">
            <thead>
              <tr>
                <th class="ts-uppercase ts-bg-gray-100">#</th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.serialNo') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.date') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.productName') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.imei') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.grade') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.type') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.warehouse') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.status') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.qcBy') }}
                </th>
                <th class="ts-uppercase ts-bg-gray-100">
                  {{ $t('reportQcBy.updatedBy') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, index) in QcResources" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ r.serial_no }}</td>
                <td>{{ r.qc_date }}</td>
                <td>{{ r.product_name_en }}</td>
                <td>{{ r.imei }}</td>
                <td>{{ r.product_grade }}</td>
                <td>{{ r.product_type_en }}</td>
                <td>{{ r.location_name }}</td>
                <td>{{ r.sn_status }}</td>
                <td>{{ r.qc_by }}</td>
                <td>{{ r.qc_input_by }}</td>
              </tr>
            </tbody>
          </table>
        </ts-loading-banner>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="QcPagination" @navigate="fetchData">
          </ts-pagination>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { join, trim } from 'lodash'
import * as FileDownload from 'downloadjs'

export default {
  name: 'qcByReport',
  data() {
    return {
      loading: false,
      users: [],
      date_range: [
        moment()
          .add(-7, 'day')
          .format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
      ],
      qc_by_id: undefined
    }
  },
  computed: {
    ...mapState('report/inventory', ['QcPagination', 'QcResources'])
  },
  methods: {
    ...mapActions('report/inventory', ['qcBy', 'qcByExcel']),
    ...mapActions('report/resource', ['getCashier']),
    fetchData(attributes = {}) {
      let params = Object.assign(
        {
          filter: {
            qc_by_id: this.qc_by_id,
            date_between: join(this.date_range, ',')
          }
        },
        attributes
      )
      this.loading = true
      this.qcBy(params).finally(() => (this.loading = false))
    },
    fetchUser() {
      this.loading = true
      this.getCashier()
        .then(res => {
          this.users = res.data.map(el => ({
            value: el.user_id,
            label: el.name
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadExcel() {
      this.loading = true
      this.qcByExcel({
        date_range: this.date_range,
        qc_by_id: this.qc_by_id
      })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchUser()
      vm.fetchData()
    })
  }
}
</script>
